import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import GUID from "../helpers/uuidHelper";
import Table, { TableBody, TableHeader } from "@ingka/table";
import RadioButton from "@ingka/radio-button";
import Container from "../components/layout/Container";
import { getFormattedDateTime } from "../helpers/dateTimeFormatHelper";

const Th = styled.th`
	display: ${props => (props.setDisplay ? "table-cell" : "none")};
`;

const Td = styled.td`
	display: ${props => (props.setDisplay ? "table-cell" : "none")};
`;

const DeliveryAndServiceView = ({ orderDetails, columnConfigurations, onSelectionChange }) => {
	const columns = Object.keys(columnConfigurations);
	return (
		<>
			<Container marginleft={"30px"} margintop={"10px"}>
				<h3>Service information</h3>
			</Container>
			<Container justifyContent={"flex-start"} marginleft={"80px"} marginright={"30px"} marginbottom={"30px"} maxwidth={"90%"}>
				<Table>
					<TableHeader sticky={false}>
						<tr>
							{columns.map(column => {
								const columnConfig = columnConfigurations[column];
								return (
									<Th key={GUID.Guid()} setDisplay={columnConfig.shouldDisplay}>
										{columnConfig.title}
									</Th>
								);
							})}
						</tr>
					</TableHeader>

					{orderDetails.map(detail => {
						const orderDetail = {
							...detail,
							serviceDate: getFormattedServiceDate(detail.serviceDate, detail.countryCode)
						};

						return (
							<TableBody key={GUID.Guid()}>
								<tr key={GUID.Guid()}>
									{columns.map(column => {
										const columnConfig = columnConfigurations[column];
										if (columnConfig.title === "") {
											return orderDetail.isSelected !== undefined ? (
												<Td key={GUID.Guid()} setDisplay={true}>
													{/* Button is disabled when order is not processible (applies to all orders). */}
													{<RadioButton id={orderDetail.rowId} checked={orderDetail.isSelected} onChange={e => onSelectionChange(e)} disabled={!orderDetail.isProcessible} />}
												</Td>
											) : (
												<Td key={GUID.Guid()} setDisplay={true}></Td>
											);
										} else {
											return (
												<Td key={GUID.Guid()} setDisplay={columnConfig.shouldDisplay}>
													{orderDetail[column]}
												</Td>
											);
										}
									})}
								</tr>
							</TableBody>
						);
					})}
				</Table>
			</Container>
		</>
	);
};

const getFormattedServiceDate = (serviceDate, countryCode) => {
	let formattedServiceDate = " ";
	if (serviceDate === "---") {
		formattedServiceDate = serviceDate;
	} else if (serviceDate !== undefined && serviceDate !== "") {
		formattedServiceDate = getFormattedDateTime(serviceDate, countryCode);
	}

	return formattedServiceDate;
};

DeliveryAndServiceView.propTypes = {
	orderDetails: PropTypes.array.isRequired,
	columnConfigurations: PropTypes.object.isRequired
};

export default DeliveryAndServiceView;
